import { useObserver } from "mobx-react";
import ResumeUploader from "./resumeUploader";
import GeneratePopup from "../../recruiter/Resume/GeneratePopup";
import Report from "./report";
import { useStores } from "../../../store";
import { GetMoreCreditsPopUp } from "../basicDetails";
import PreviousResults from "./previousResults";
import { useEffect } from "react";

export default function ResumeAnalyzer() {
  const { UserStore, PopupStore } = useStores();
  useEffect(() => {
    UserStore.getAllPreviousResumes();
  }, []);
  return useObserver(() => (
    <div className="my-14 md:my-0">
      {PopupStore.getMoreCredits && (
        <GetMoreCreditsPopUp
          popUpInitialValue={PopupStore.getMoreCredits}
          handlePopup={() => {
            PopupStore.setGetMoreCredits(false);
          }}
        />
      )}
      <h1 className="text-primary text-2xl font-bold border-b border-[#ccdod6] py-6 md:py-10 px-4 md:px-10 ">
        Resume Analyzer
      </h1>
      <GeneratePopup />

      <ResumeUploader />
      {!UserStore.resumeReport && <PreviousResults />}
      {UserStore.resumeReport && <Report />}
    </div>
  ));
}
